/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { CallidusCharterVersicherungspraemieCalcDto } from '../model/callidus-charter-versicherungspraemie-calc-dto.model';
// @ts-ignore
import { ProductCallidusPipelineResultDto } from '../model/product-callidus-pipeline-result-dto.model';
// @ts-ignore
import { PublicCallidusCharterContractCreateDto } from '../model/public-callidus-charter-contract-create-dto.model';
// @ts-ignore
import { VersicherungspraemieCalculationResultDto } from '../model/versicherungspraemie-calculation-result-dto.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class PublicCallidusCharterApiService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @endpoint post /api/public-callidus-charter/contract
     * @param publicCallidusCharterContractCreateDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPublicCallidusCharterContractPost(publicCallidusCharterContractCreateDto: PublicCallidusCharterContractCreateDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ProductCallidusPipelineResultDto>;
    public apiPublicCallidusCharterContractPost(publicCallidusCharterContractCreateDto: PublicCallidusCharterContractCreateDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProductCallidusPipelineResultDto>>;
    public apiPublicCallidusCharterContractPost(publicCallidusCharterContractCreateDto: PublicCallidusCharterContractCreateDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProductCallidusPipelineResultDto>>;
    public apiPublicCallidusCharterContractPost(publicCallidusCharterContractCreateDto: PublicCallidusCharterContractCreateDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (publicCallidusCharterContractCreateDto === null || publicCallidusCharterContractCreateDto === undefined) {
            throw new Error('Required parameter publicCallidusCharterContractCreateDto was null or undefined when calling apiPublicCallidusCharterContractPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/public-callidus-charter/contract`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ProductCallidusPipelineResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: publicCallidusCharterContractCreateDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/public-callidus-charter/contract/versicherungspraemie
     * @param callidusCharterVersicherungspraemieCalcDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPublicCallidusCharterContractVersicherungspraemiePost(callidusCharterVersicherungspraemieCalcDto: CallidusCharterVersicherungspraemieCalcDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VersicherungspraemieCalculationResultDto>;
    public apiPublicCallidusCharterContractVersicherungspraemiePost(callidusCharterVersicherungspraemieCalcDto: CallidusCharterVersicherungspraemieCalcDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VersicherungspraemieCalculationResultDto>>;
    public apiPublicCallidusCharterContractVersicherungspraemiePost(callidusCharterVersicherungspraemieCalcDto: CallidusCharterVersicherungspraemieCalcDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VersicherungspraemieCalculationResultDto>>;
    public apiPublicCallidusCharterContractVersicherungspraemiePost(callidusCharterVersicherungspraemieCalcDto: CallidusCharterVersicherungspraemieCalcDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (callidusCharterVersicherungspraemieCalcDto === null || callidusCharterVersicherungspraemieCalcDto === undefined) {
            throw new Error('Required parameter callidusCharterVersicherungspraemieCalcDto was null or undefined when calling apiPublicCallidusCharterContractVersicherungspraemiePost.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/public-callidus-charter/contract/versicherungspraemie`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VersicherungspraemieCalculationResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: callidusCharterVersicherungspraemieCalcDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
